import React, { useEffect, useState } from 'react';
import { console_, telechargerBlob } from '../services/api';
import { dateFr, dateHeureFr, n } from '../services/format';
import { Erreur, Chargement, messageErreur } from './Ui';

// Journal d'audit (append-only), sceaux quotidiens de la chaîne de preuves,
// export CSV des consentements (DPO / admin).
export default function Journal() {
  const [journal, setJournal] = useState(null);
  const [sceaux, setSceaux] = useState([]);
  const [action, setAction] = useState('');
  const [societe, setSociete] = useState('');
  const [societes, setSocietes] = useState([]);
  const [erreur, setErreur] = useState('');

  const charger = (a) => console_.journal({ limit: 300, action: a || undefined }).then((r) => setJournal(r.data)).catch((e) => setErreur(messageErreur(e)));
  useEffect(() => {
    charger('');
    console_.sceaux().then((r) => setSceaux(r.data)).catch(() => {});
    console_.config().then((r) => setSocietes(r.data.societes)).catch(() => {});
  }, []);

  const exporter = async () => {
    try {
      const r = await console_.exporter(societe ? { societe } : {});
      telechargerBlob(r.data, `consentements-${societe || 'toutes'}-${new Date().toISOString().slice(0, 10)}.csv`);
    } catch (e) { setErreur(messageErreur(e)); }
  };

  return (
    <div>
      <h1 className="rg-titre-page">Journal</h1>
      <Erreur message={erreur} />
      <section className="rg-section">
        <h2>Export des consentements<small>CSV, séparateur « ; », pour un contrôle ou une demande d'accès</small></h2>
        <div className="rg-actions" style={{ alignItems: 'center', marginTop: 0 }}>
          <select value={societe} onChange={(e) => setSociete(e.target.value)} style={{ padding: 8 }}>
            <option value="">Toutes les sociétés</option>
            {societes.map((s) => <option key={s.id} value={s.code}>{s.raison_sociale}</option>)}
          </select>
          <button className="rg-btn rg-btn--principal" onClick={exporter}>Exporter</button>
        </div>
      </section>

      <section className="rg-section">
        <h2>Sceaux quotidiens<small>hachage de tête de la chaîne de preuves</small></h2>
        {sceaux.length === 0 ? <p className="rg-info">Aucun sceau : le premier est posé par la tâche quotidienne (ou Configuration ▸ Tâches ▸ sceller).</p> : (
          <div className="rg-defile">
            <table className="rg-tableau">
              <thead><tr><th>Jour</th><th className="rg-num">Preuves</th><th>Hachage de tête</th><th>Posé le</th></tr></thead>
              <tbody>{sceaux.map((s) => <tr key={s.id}><td>{dateFr(s.jour)}</td><td className="rg-num">{n(s.nb_preuves)}</td><td className="rg-mono">{s.sha256_tete || '—'}</td><td>{dateHeureFr(s.created_at)}</td></tr>)}</tbody>
            </table>
          </div>
        )}
      </section>

      <section className="rg-section">
        <h2>Événements<small>300 derniers</small></h2>
        <div className="rg-recherche">
          <input value={action} onChange={(e) => setAction(e.target.value)} placeholder="Filtrer par action (ex. consentement, demande, cle)" />
          <button className="rg-btn" onClick={() => charger(action)}>Filtrer</button>
        </div>
        {!journal ? <Chargement /> : (
          <div className="rg-defile">
            <table className="rg-tableau">
              <thead><tr><th>Horodatage</th><th>Acteur</th><th>Action</th><th>Cible</th><th>Détail</th></tr></thead>
              <tbody>
                {journal.map((j) => (
                  <tr key={j.id}>
                    <td style={{ whiteSpace: 'nowrap' }}>{dateHeureFr(j.created_at)}</td>
                    <td>{j.acteur}</td>
                    <td>{j.action}</td>
                    <td className="rg-mono">{j.cible || ''}</td>
                    <td className="rg-mono">{j.detail ? JSON.stringify(j.detail) : ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
